import { aiInRecruitingChallengesSectionData } from 'constants/AiInRecruiting'
import Image from 'next/image'
import styles from './AiInRecruitingChallengesSection.module.css'

const AiInRecruitingChallengesSection = () => {
  const {
    titleOrange,
    titleBlack,
    subtitle,
    headerChallenge,
    headerSolution,
    rows,
  } = aiInRecruitingChallengesSectionData

  return (
    <section className={styles.challengesSection}>
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-12 col-lg-5">
            <h2 className={styles.sectionTitle}>{titleBlack}</h2>
            <p className={styles.subtitle}>{subtitle}</p>
          </div>

          <div className="col-12 col-lg-6">
            <div className={styles.tableOuter}>
              <div className={styles.mainTitle}>
                <span>Ai In Recruiting</span>
              </div>
              <div className={styles.tableWrapper}>
                <table className={styles.table}>
                  <thead>
                    <tr className={styles.headerRow}>
                      <th className={styles.headerChallenge}>
                        {headerChallenge}
                      </th>
                      <th className={styles.headerSolution}>
                        {headerSolution}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, i) => (
                      <tr key={i} className={styles.row}>
                        <td className={styles.challengeCell}>
                          {row.challenge}
                        </td>
                        <td className={styles.solutionCell}>{row.solution}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AiInRecruitingChallengesSection
